import { useBooleanState, useUpdateEffect } from '@cian/react-utils';

import { type FC } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { useChatUrlSelector } from '@/packages/redux-state/store/slices/chat';

import { ChatPopup } from './ChatPopup';

const useBoundActions = boundActionsFactory(reduxActions => ({
  deleteActiveChatUrl: reduxActions.chat.deleteActiveChatUrl,
}));

export const ChatPopupContainer: FC = () => {
  const activeChatUrl = useChatUrlSelector();

  const boundActions = useBoundActions();

  const { state, setFalse, setTrue } = useBooleanState();

  useUpdateEffect(() => {
    if (activeChatUrl) {
      setTrue();
    } else {
      setFalse();
    }
  }, [activeChatUrl]);

  if (!activeChatUrl) {
    return null;
  }

  return (
    <ChatPopup
      isLoading={state}
      key={activeChatUrl}
      url={activeChatUrl}
      onClose={boundActions.deleteActiveChatUrl}
      onError={setFalse}
      onLoad={setFalse}
    />
  );
};
